import { Role } from '@/api/types'

export default [
    {
        name: 'tasks',
        path: '/tasks',
        redirect: { name: 'tasks_all' },
        meta: {
            requiredRole: Role.EMPLOYEE,
        },
        component: () => import(/* webpackChunkName: "tasks" */ '../../views/Tasks/Tasks.vue'),
        children: [
            {
                name: 'tasks_all',
                path: '/tasks/all',
                meta: {
                    requiredRole: Role.EMPLOYEE,
                },
                component: () => import(/* webpackChunkName: "tasks_list" */ '../../views/Tasks/List.vue'),
            },
            {
                name: 'tasks_unscheduled',
                path: '/tasks/unscheduled',
                redirect: { name: 'tasks_all'} ,
            },
            {
                name: 'tasks_assigned',
                path: '/tasks/assigned',
                redirect: { name: 'tasks_all' },
            },
            {
                name: 'tasks_referred',
                path: '/tasks/referred',
                redirect: { name: 'tasks_all' },
            },
            {
                name: 'tasks_detail',
                path: '/tasks/:referralId',
                props: true,
                meta: {
                    requiredRole: Role.EMPLOYEE,
                },
                component: () => import(/* webpackChunkName: "tasks_detail" */ '../../views/Tasks/Detail.vue'),
                children: [
                    {
                        name: 'tasks_detail_emma_appraisal',
                        path: '/tasks/:referralId/emma_appraisal',
                        props: true,
                        meta: {
                            requiredRole: Role.EMPLOYEE,
                        },
                        component: () => import(/* webpackChunkName: "tasks_detail_emma_appraisal" */ '../../views/Tasks/Detail/ReferralDetails/EmmaAppraisal.vue'),
                    },
                    {
                        name: 'tasks_detail_future_address',
                        path: '/tasks/:referralId/future_address',
                        props: true,
                        meta: {
                            requiredRole: Role.EMPLOYEE,
                        },
                        component: () => import(/* webpackChunkName: "tasks_detail_future_address" */ '../../views/Tasks/Detail/ReferralDetails/FutureAddress.vue'),
                    },
                    {
                        name: 'tasks_detail_financial',
                        path: '/tasks/:referralId/financial',
                        props: true,
                        meta: {
                            requiredRole: Role.EMPLOYEE,
                        },
                        component: () => import(/* webpackChunkName: "tasks_detail_financial" */ '../../views/Tasks/Detail/ReferralDetails/Financial.vue'),
                    },
                    {
                        name: 'tasks_detail_files',
                        path: '/tasks/:referralId/files',
                        props: true,
                        meta: {
                            requiredRole: Role.EMPLOYEE,
                        },
                        component: () => import(/* webpackChunkName: "tasks_detail_files" */ '../../views/Tasks/Detail/ReferralDetails/Files.vue'),
                    },
                ],
            },
        ],
    },
]
